import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import { informacionBasicaReducer } from "../reducers/informacionBasicaReducer";
import { padreReducer } from "../reducers/padreReducer";
import thunk from "redux-thunk";
import { captchaReducer } from "../reducers/captchaReducer";
import { regionReducer, provinciaReducer, distritoReducer,
        regionMuniReducer, provinciaMuniReducer, distritoMuniReducer } from "../reducers/ubigeoReducer";
import { institucionReducer } from "../reducers/instEducativaReducer";
import { estudianteReducer } from "../reducers/estudianteReducer";
import { preguntaReducer } from "../reducers/preguntaReducer";
import { veeduriaReducer } from "../reducers/veeduriaReducer";
import { formatoReducer } from "../reducers/formatoReducer";
import { municipalidadReducer } from "../reducers/municipalidadReducer";
import { tipoDocumentoReducer, tipoInstEduReducer, nacionalidadReducer } from "../reducers/parametroReducer";
import { coordenadasReducer } from "../reducers/coordenadasReducer";

const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose

const reducers = combineReducers( {
    informacion_basica: informacionBasicaReducer,
    padre: padreReducer,
    captcha: captchaReducer,
    regiones: regionReducer,
    provincias: provinciaReducer,
    distritos: distritoReducer,
    instituciones: institucionReducer,
    estudiante: estudianteReducer,
    pregunta: preguntaReducer,
    veeduria: veeduriaReducer,
    formatos: formatoReducer,
    tipos_documento: tipoDocumentoReducer,
    tipos_inst_edu: tipoInstEduReducer,
    nacionalidades: nacionalidadReducer,
    regionesMuni: regionMuniReducer,
    provinciasMuni: provinciaMuniReducer,
    distritosMuni: distritoMuniReducer,
    municipalidades: municipalidadReducer,
    coordenadas: coordenadasReducer,
} );

export const store = createStore(
    reducers,
    composeEnhancers( applyMiddleware( thunk ) )
)